import React, { Suspense, memo, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@/store/rootReducer";
import type { AppDispatch } from "@/store/store";
import { setSidebarOpen } from "@/store/slices/globalSlice";


// import Sidebar from "./components/Sidebar/Sidebar";
// import Navbar from "./components/Navbar/Navbar";
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";

import styles from "../DisPostLogin/DisPostLogin.module.scss";
import Sidebar from "../DisPostLogin/Components/Sidebar/Sidebar";
import Navbar from "../DisPostLogin/Components/Navbar/Navbar";




const PostLogin: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  const sidebarOpen = useSelector(
    (state: RootState) => state.global.sidebarOpen
  );

  /**
   * Toggle sidebar open/close with event prevention
   */
  const toggleSidebarOpen = useCallback(
    (flag: boolean) => () => {
      if (sidebarOpen !== flag) {
        dispatch(setSidebarOpen(flag));
      }
    },   
    [dispatch, sidebarOpen]
  );

  return (
    <div>
      <Navbar/>
     <div className={styles.layout}>
      <Sidebar toggleSidebarOpen={toggleSidebarOpen} />
      
      <div className={styles .rightSideContainer}>
       
        <div className={styles.outletDiv} >
          <Suspense fallback={<Loader />}>
            <ErrorBoundary>
              <Outlet key={location.pathname} />
            </ErrorBoundary>
          </Suspense>
        </div>
      </div>
    </div>
    </div>
    
  );
};

export default memo(PostLogin);
